import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiGrid, FiActivity, FiMail } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const MobileFooter = () => {
  const navItems = [
    { name: 'Home', icon: FiHome, path: '/' },
    { name: 'Services', icon: FiGrid, path: '/services' },
    { name: 'Therapy', icon: FiActivity, path: '/therapies' },
    { name: 'Contact', icon: FiMail, path: '/contact' }
  ];

  const handleFooterClick = (e) => {
    // Prevent event bubbling to avoid closing mobile drawer
    e.stopPropagation();
  };

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 w-full" onClick={handleFooterClick}>
      <div className="bg-white/80 backdrop-blur-xl shadow-2xl shadow-emerald-900/10 h-[70px] flex items-center justify-around relative overflow-hidden">
        {/* Glass reflection effect */}
        <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/60 to-transparent"></div>
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center w-full h-full space-y-1 transition-all duration-300 outline-none border-none focus:outline-none focus:border-none focus:ring-0 p-0 ${
                isActive
                  ? 'text-emerald-600 scale-105'
                  : 'text-gray-400 hover:text-gray-600'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`relative p-1.5 rounded-xl transition-all duration-300 ${isActive ? 'bg-emerald-100' : 'bg-transparent'}`}>
                  <SafeIcon icon={item.icon} className={`w-5 h-5 ${isActive ? 'fill-current' : ''}`} />
                  {isActive && (
                    <span className="absolute -top-1 -right-1 w-2 h-2 bg-emerald-500 rounded-full shadow-sm"></span>
                  )}
                </div>
                <span className={`text-[10px] font-bold tracking-wide ${isActive ? 'text-emerald-700' : 'text-gray-400'}`}>
                  {item.name}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default MobileFooter;
